import { notifyAnalytics } from '@/api/analytics/notifyAnalytics'
import { keycloak } from '@/main'

/**
 * API Call to logout the user.
 * This will invalidate the directus connection if successful and is a fire and forget style function.
 */
export async function logout() {
  try {
    await keycloak.logout({
      redirectUri: window.location.origin,
    })
  } catch (error) {
    notifyAnalytics({ type: 'log_error', data: error })
  }
}
